import { useQuery } from '@tanstack/react-query';
import { Select } from '@customerio/pluma-components/react';
import { requireWorkspaceId } from '@/services/db/shared/workspace';
import { getWorkspaceTagsQueryOptions } from '@/services/db/tag/queries';
import { toIdList } from './multi-select-values';

type TagFilterProps = {
  selectedTagIds: readonly string[];
  onTagIdsChange: (tagIds: string[]) => void;
  placeholder?: string;
};

/** Filters a list by one or more of the workspace's tags. */
export function TagFilter({ selectedTagIds, onTagIdsChange, placeholder = 'Search tags' }: TagFilterProps) {
  const tagsQuery = useQuery(getWorkspaceTagsQueryOptions(requireWorkspaceId()));
  const options = (tagsQuery.data ?? []).map((tag) => ({ value: String(tag.id), label: tag.name }));

  return (
    <Select
      size="sm"
      isMulti
      isSearchable
      isDisabled={tagsQuery.isPending}
      options={options}
      placeholder={placeholder}
      ariaLabel="Tags"
      value={[...selectedTagIds]}
      onChange={(value: string | string[] | null) => onTagIdsChange(toIdList(value))}
    />
  );
}
